import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getImportStatusById } from '../../../api';

export const importsByIdStatusGetSlice = createGetAsyncSlice({
	name: 'ImportsByIdStatus',
	receive: true,
	request: true,
	requestHandler: getImportStatusById,
	retainDataOnRequest: true
});
